export class Avatar {
  protected name: string = '';
  protected options: AvatarOptions = {
    initials: 'AT',
    color: '#000000',
    background: '#FFFFFF',
    size: 512,
    // heihgt & width -> als een van de twee auto pak de waarde van de ander
  };

  constructor(name: string, options?: AvatarOptions) {
    this.options = {...this.options, ...options};
    this.options.initials = this.generateInitials(name);
  }

  private generateInitials(name: string) {
    if (!name) {
      return;
    }
    const initials =  name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

    if(initials) {
      const joined = initials.join('').toLowerCase();
      if(joined.length > 3) {
        return joined.substr(0, 3);
      }
      return joined;
    }

    return '';
  }

  public toDataUrl() {
    const canvas = document.createElement('canvas');
    const width = this.options.size || 512;
    const height = this.options.size || 512;
    canvas.width = width
    canvas.height = height
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;


    const context = canvas.getContext('2d', {alpha: false});
    if(context) {
      context.rect(0, 0, canvas.width, canvas.height);
      context.fillStyle = this.options.background || '#FFFFFF';
      context.fill();
      context.font = `400 ${height / 2.5}px Arial`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillStyle = this.options.color || '#000000';
      context.fillText(this.options.initials || 'AT', (width / 2), (height / 2));
    }

    return canvas.toDataURL('image/png') || '';

  }
}

export interface AvatarOptions {
  initials?: string;
  color?: string;
  background?: string;
  size?: number;
}
